import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { InternalBankHistoryItem } from "../../financial.types";
import { requestInternalBankHistory } from "./internalBankHistory.request";

const useInternalBankHistory = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<InternalBankHistoryItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["internal-bank-history", requestParams],
    queryFn: async () => await requestInternalBankHistory(requestParams),
    ...options
  });

  return { history: data?.data ?? [], meta: data?.meta, ...rest };
};

export default useInternalBankHistory;
